/*

Sainapse® incorporates patented, and “patent pending”, technology.

© 2017 - 2024 Sainapse Inc. and its licensors. All rights reserved worldwide.

Sainapse Inc. and its licensors own all rights in this work, including but not limited to the source code, algorithms, text, 
flowcharts and images herein, which are protected by copyright laws in applicable jurisdictions. Any use of this work is permissible 
only with an express written license or authorization from Sainapse Inc., and only to the extent and for the purpose permitted. 
Unauthorized copying, editing, reproduction, redistribution, modification, creation of derivative works, translation, adaptation, 
customization, decompilation, reverse engineering, disassembling or hacking of this work or any part thereof, including but not limited to the source code, 
header files and libraries of the software, via any medium is strictly prohibited.

Open Source Software that is provided as part of Sainapse® is subject to and governed solely by the terms and conditions of the applicable open source license agreements, 
and their respective terms, conditions, restrictions and obligations, a copy of which will be made available to you upon request.

Proprietary and Confidential. Sainapse® and associated documentation is the property of Sainapse Inc. and considered confidential information. 
No part of it may be disclosed without the express written consent of Sainapse Inc.Please note that any infringement or violation will invite legal action, 
both civil and criminal, as appropriate, without any further notice.

*/
import React, { Component, Fragment } from 'react';

import { withStyles, createMuiTheme, ThemeProvider } from '@material-ui/core/styles'

import { Popper, Paper, ClickAwayListener, Chip, Typography } from '@material-ui/core'

import StatusIcon from '../StatusIcon'
import InformationUnit from './InformationUnit'


const blue_theme = createMuiTheme({
    palette: {
      primary: {
        main: "#2296f3",
      },
      secondary: {
        main: "#dc004e",
      },
    },
});

const style = theme => ({
    arrow  : {
        position : 'absolute',
        fontSize: '7px',
        width: '3em',
        height: '3em',

        '&:before' :  {
          content: '""',
          margin: 'auto',
          display: 'block',
          width: 0,
          height: 0,
          borderStyle: 'solid'
        }
    }
})

class IUDataStatus extends Component {
    state = {
        open : false,
        anchorEl : null,
        arrowRef : null,
        connection_state : false,
        access_cred : false,
        adaptor_inputs : false,
        fields_in_scope : false,
        wv_map : false
    }

    componentDidMount () {
        let access_cred = this.checkState(this.props.iu.access_details, null)
        let adaptor_inputs = this.checkState(this.props.iu.access_parameters, null)
        let fields_in_scope = this.checkState(this.props.iu.fields_in_scope, null)
        let wv_map = this.checkState(this.props.iu.iu_world_view, null)

        this.setState({
            ...this.state,
            access_cred : access_cred,
            adaptor_inputs : adaptor_inputs,
            fields_in_scope : fields_in_scope,
            wv_map : wv_map
        }, () => {
            let state = this.state
            if (state.access_cred && state.adaptor_inputs && state.fields_in_scope && state.wv_map) {
                this.setState({
                    ...this.state,
                    connection_state : true
                })
            } else {
                this.setState({
                    ...this.state,
                    connection_state : false
                })
            }
        })
    }

    checkState = (prop_obj,falsy_val) => {
        if (prop_obj === falsy_val) {
            return false
        } else {    
            return true
        }
    }

    togglePopper = (event) => {
        this.setState({
            ...this.state, 
            open : !this.state.open,
            anchorEl : event.currentTarget
        })
    }

    handleClose = () => {
        this.setState({
            ...this.state,
            open : false,
            anchorEl : null
        })
    }

    handleArrowRef = node => {
        this.setState({
          arrowRef: node,
        });
    };

    renderPopper = () => {
        return (
            <Popper
                key = {"training-trigger"}
                open={this.state.open}
                anchorEl={this.state.anchorEl}
                placement="bottom-start"
                modifiers={{
                    flip: {
                        enabled: true,
                    },
                    preventOverflow: {
                        enabled: false,
                        boundariesElement: 'scrollParent',
                    },
                    arrow: {
                        enabled: true,
                        element: this.state.arrowRef,
                    },
                }}
            >
                <ClickAwayListener onClickAway = {this.handleClose}>
                    <Paper elevation = {5} square style = {{width : '500px', padding : '5px'}}>
                        {
                            true &&
                            <span className="arrow" ref={this.handleArrowRef} />
                        }
                        <InformationUnit iu = {this.props.iu} show_connection = {true} show_data_transfer = {false} show_actions = {false}/>
                    </Paper>
                </ClickAwayListener>
            </Popper>
        )
    }

    renderStatusIcon = () => {
        return (
            <StatusIcon style = {{...this.props.style}} status = {this.props.iu.data_transfer_status} status_clicked = {(event) => this.togglePopper(event)} prefix = {this.props.iu.name} in_progress = "arrow"/>
        )
    }

    render() { 
        return (
            <Fragment>
                <ThemeProvider theme = {blue_theme}>
                    {this.renderStatusIcon()}
                    {this.renderPopper()}
                </ThemeProvider>
            </Fragment>
        );
    }
}
 
export default IUDataStatus;